export default __webpack_public_path__ + "static/media/ic_wallet.3ef41b10775656a60062ee31c62cc973.svg";